import angular from 'angular'

import { wrap, flow } from 'lodash-es'
import { withoutOnce } from '../utils/arrayh'
import { toList, defaultTo, isEmptyArray } from '../utils/bits'

import StrictObj from '../utils/strict-obj'
import extractRawElm from '../utils/extract-raw-elm'

import { READY_ATTR, LOADED_ATTR, OPEN_POPUPS_ATTR } from '../utils/shared-constants'

angular
  .module('ggs.gallery')
  .factory('AttributesManager', AttributesManagerProvider)

function AttributesManagerProvider(
  $rootElement,
  DefineMethod,
  DefineHandler) {

  return function AttributesManager(readyStateManager) {
    const sign = 'galleryMain::attributesManager'
    const rootElm = extractRawElm($rootElement)

    const manager = StrictObj({
      wrapM: DefineMethod(sign),
      wrapH: DefineHandler(sign)
    })

    manager.wrapM('reportReady', () => {
      rootElm.setAttribute(READY_ATTR, true)
    })

    manager.wrapM('reportLoaded', () => {
      rootElm.setAttribute(LOADED_ATTR, true)
    })

    manager.wrapM('reportPopupOpen', (popupQs) => {
      const prevPopups = readPopupOpensAttr()
      const currPopups = prevPopups.concat(popupQs)
      writePopupOpensAttr(currPopups)
    })

    manager.wrapM('reportPopupClosed', (popupQs) => {
      const prevPopups = readPopupOpensAttr()
      const currPopups = withoutOnce(prevPopups, popupQs)
      writePopupOpensAttr(currPopups)
    })

    manager.wrapM('init',
      flow(
        wrap(manager.reportReady, readyStateManager.readyEmitter.on),
        wrap(manager.reportLoaded, readyStateManager.loadedEmitter.on)))

    manager.wrapM('destroy',
      flow(
        wrap(manager.reportReady, readyStateManager.readyEmitter.off),
        wrap(manager.reportLoaded, readyStateManager.loadedEmitter.off)))

    return manager

    function readPopupOpensAttr() {
      return defaultTo(toList(rootElm.getAttribute(OPEN_POPUPS_ATTR)), [])
    }

    function writePopupOpensAttr(popups) {
      if (isEmptyArray(popups)) {
        rootElm.removeAttribute(OPEN_POPUPS_ATTR)
      } else {
        rootElm.setAttribute(OPEN_POPUPS_ATTR, popups.join(','))
      }

      return popups
    }
  }
}
